<template>
    <div class="my-6">
        <p>{{ __('choisissez_votre_date') }}</p>
        <div class="flex my-2">
            <div class="w-1/2 text-center">
                <select @change="resetSelectedDates" v-model="$parent.datePicker.mois" name="mois">
                    <option v-for="(item, key) in mois" :value="key">{{ __(item) }}</option>
                </select>
            </div>
            <div class="w-1/2 text-center">
                <select @change="resetSelectedDates" v-model="$parent.datePicker.annee" name="annee">
                    <option v-for="item in annees" :value="item">{{ item }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DatePicker",
    data: function () {
        return {
            mois: [
                'janvier',
                'fevrier',
                'mars',
                'avril',
                'mai',
                'juin',
                'juillet',
                'aout',
                'septembre',
                'octobre',
                'novembre',
                'decembre'
            ],
            annees: [],
        }
    },
    methods: {
        resetSelectedDates() {
            this.$parent.form.programmes = [];
        },
    },
    created:function() {
        if(this.$parent.produit.par_niveau && this.$parent.datesParNiveau.length) {
            for (let programme in this.$parent.datesParNiveau) {
                let date = this.$parent.datesParNiveau[programme].date_debut_inscription;
                if (!date)
                    date = this.$parent.datesParNiveau[programme].date_debut;

                // On affiche distinctement les années contenant des dates
                if (this.annees.indexOf((new Date(date)).getFullYear()) === -1)
                    this.annees.push((new Date(date)).getFullYear());
            }
        } else if(this.$parent.produit.enfants.length && Object.keys(this.$parent.datesEnfants).length) {
            for (let programme in this.$parent.datesEnfants) {
                let date = this.$parent.datesEnfants[programme].date_debut_inscription;
                if (!date)
                    date = this.$parent.datesEnfants[programme].date_debut;

                // On affiche distinctement les années contenant des dates
                if (this.annees.indexOf((new Date(date)).getFullYear()) === -1)
                    this.annees.push((new Date(date)).getFullYear());
            }
        } else if(!this.$parent.produit.par_niveau && !this.$parent.produit.enfants.length && this.$parent.produit.programmes.length) {
            for (let programme in this.$parent.produit.programmes) {
                let date = this.$parent.produit.programmes[programme].date_debut_inscription;
                if (!date)
                    date = this.$parent.produit.programmes[programme].date_debut;

                // On affiche distinctement les années contenant des dates
                if (this.annees.indexOf((new Date(date)).getFullYear()) === -1)
                    this.annees.push((new Date(date)).getFullYear());
            }
        } else {
            this.annees.push((new Date()).getFullYear());
        }
    },
}
</script>

<style scoped>

</style>
